import React from "react";
import {
  Assignment,
  Print,
  PriorityHigh,
  FactCheck,
} from "@mui/icons-material";

export const loadingMenuOptions = [
  {
    id: "statementOfFact",
    label: "Statement of Fact",
    roles: ["admin", "master", "chiefofficer", "officer"],
    icon: <Assignment />,
  },
  {
    id: "logging",
    label: "Load Logg",
    roles: ["admin", "master", "chiefofficer", "officer"],
    icon: <Assignment />,
  },
];

export const loadingPrintableDocuments = [
  {
    id: "nor",
    label: "Notice Of Readiness",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Print />,
  },
  {
    id: "slop",
    label: "SLOP Reports",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Assignment />,
  },
  {
    id: "rcs",
    label: "Receiving Capacity Statement",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Print />,
  },
  {
    id: "ctc",
    label: "Clean Tank Cert.",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Print />,
  },
  {
    id: "protests",
    label: "Protests",
    roles: ["admin", "master", "chiefofficer"],
    icon: <PriorityHigh />,
  },
];

export const dischargeMenuOptions = [
  {
    id: "statementOfFact",
    label: "Statement of Fact",
    roles: ["admin", "master", "chiefofficer", "officer"],
    icon: <Assignment />,
  },
  {
    id: "logging",
    label: "Pump Logg",
    roles: ["admin", "master", "chiefofficer", "officer"],
    icon: <Assignment />,
  },
];

export const dischargePrintableDocuments = [
  {
    id: "nor",
    label: "Notice Of Readiness",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Print />,
  },
  {
    id: "slop",
    label: "SLOP Reports",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Assignment />,
  },
  {
    id: "pumpstatement",
    label: "Pump Statement",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Print />,
  },
  {
    id: "etc",
    label: "Empty Tank Cert.",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Print />,
  },
  {
    id: "protests",
    label: "Protests",
    roles: ["admin", "master", "chiefofficer"],
    icon: <PriorityHigh />,
  },
];

export const otherMenuOptions = [
  /* {
    id: "checklists",
    label: "Checklists",
    roles: ["admin", "master", "chiefofficer", "officer", "crew"],
    icon: <Check />,
  },
  {
    id: "permits",
    label: "Permits",
    roles: ["admin", "master", "chiefofficer"],
    icon: <WorkspacePremium />,
  }, */
  {
    id: "vef",
    label: "Vessel Experience Factor",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Print />,
  },
  {
    id: "threelastcargoes",
    label: "Three Last Cargoes",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Print />,
  },
  {
    id: "obqrob",
    label: "OBQ/ROB",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Print />,
  },
  {
    id: "deadweight",
    label: "Deadweight Statement",
    roles: ["admin", "master", "chiefofficer"],
    icon: <Print />,
  },
  {
    id: "bargelogs",
    label: "Barge Logs",
    roles: ["admin", "user"],
    icon: <Assignment />,
  },
];

export const reportMenuOptions = [
  {
    id: "completedvoyages",
    label: "Completed Voyages",
    roles: ["admin", "master", "chiefofficer", "officer", "crew"],
    icon: <FactCheck />,
  },
  /* {
    id: "cargotankstatus",
    label: "Cargo Tank Status",
    roles: ["admin", "master", "chiefofficer", "officer", "crew"],
    icon: <BarChart />,
  }, */
];
